import { connect } from "react-redux";
import { Tag, Popover, Space } from "antd";
import _ from "lodash";
import { unCategorizedLookupList } from "components/pages/talents/talentListNew/helper";

const Composition = ({ val }) => {
  const compList = val?.person_search_obj?.person_attributes ?? [];

  if (compList.length === 0) {
    return (
      <p className="text-grayBlack text-xs font-medium w-fit">
        N/A
      </p>
    );
  }

  // Convert composition data into display strings
  const compContents = compList.map((comp) => {
    const matched = unCategorizedLookupList.find(
      (entry) => entry.uuid === comp.person_attribute_uuid
    );

    let value;

    if (Array.isArray(comp.list) && comp.list.length > 0) {
      value = comp.list.map((str) => _.startCase(_.toLower(str)));
    } else {
      value = {
        start_value: comp.start_value,
        end_value: comp.end_value,
      };
    }

    return matched ? matched.tag(value) : "";
  });

  const DISPLAY_LIMIT = 5;
  const limited = compContents.slice(0, DISPLAY_LIMIT);
  const hasOverflow = compContents.length > DISPLAY_LIMIT;

  return (
    <>
      {limited.map((comp, index) => (
        <Space key={`${comp}-${index}`}>
          <Tag
            color="#E0E4EB"
            style={{
              color: "#0A0C10",
              fontSize: "12px",
              fontWeight: 500,
              marginInlineEnd: "2px",
              wordWrap: "break-word",
              whiteSpace: "break-spaces",
            }}
            bordered={false}
          >
            {comp}
          </Tag>
        </Space>
      ))}

      {hasOverflow && (
        <Popover
          placement="right"
          overlayClassName="event-shift-popover"
          content={
            <div>
              {compContents.map((comp, i) => (
                <span
                  key={`${comp}-${i}`}
                  className="text-grayMuted text-xs font-medium"
                >
                  {comp}
                  {i < compContents.length - 1 ? ", " : ""}
                </span>
              ))}
            </div>
          }
        >
          <Tag
            color="#E0E4EB"
            style={{
              color: "#0A0C10",
              fontSize: "12px",
              fontWeight: 500,
              marginInlineEnd: "2px",
            }}
            bordered={false}
          >
            +{compContents.length - DISPLAY_LIMIT} more
          </Tag>
        </Popover>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  unCategorizedLookupList: state.talent.unCategorizedLookupList,
});

export default connect(mapStateToProps)(Composition);
